import { MeData } from 'data/types/me';
import { normalizeUser } from 'model/user';

const hasOrderingFunctionality = (functionality: string[]) => {
  return functionality.includes('ordering');
};

export const normalizeMe = (data: MeData) => {
  return {
    userId: data.id,
    email: data.email,
    organizationId: data.organizationId,
    status: data.status,
    needsPasswordReset: data.needsPasswordReset,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    paymentIssues: data.paymentIssues,
    user: normalizeUser(data.user),
    assignedRoles: data.assignedRoles,
    canAccessInsights: true,
    functionality: data.functionality,
    hasOrdering: hasOrderingFunctionality(data.functionality),
  };
};

export type Me = ReturnType<typeof normalizeMe>;
